import Vue from "vue"
import VueI18n from "vue-i18n"
import StickyCta from "@/features/sticky-cta/sticky-cta"
import getLocale from "@/utils/locale"
import getWindowTop from "@/utils/get-window-top"
import store from "@/store"

const initStickyCta = () => {
  const container = document.getElementById("sticky-cta")

  if (!container) {
    return
  }

  const cta = container.dataset.cta && JSON.parse(container.dataset.cta)

  Vue.use(VueI18n)
  const vm = new Vue({
    name: "StickyCtaInit",
    el: container,
    components: { StickyCta },
    store,
    i18n: new VueI18n({ locale: getLocale() }),
    data() {
      return {
        active: false
      }
    },
    render(createElement) {
      return createElement(StickyCta, {
        props: {
          active: this.active,
          cta
        }
      })
    }
  })

  const onScroll = () => {
    const ref = document.querySelector(".js-sticky-header-ref")
    const isSticky = ref ? ref.getBoundingClientRect().top < 0 : getWindowTop() > 0
    vm.active = isSticky
  }

  window.addEventListener("scroll", onScroll)
  onScroll()
}

export default initStickyCta
